import type { ExpressionType } from '../../../stores/filters';

export const normalizeInput = (value: string): string => {
  if (!value) return '';

  return value
    .split(/[,\n]/)
    .map((v) => v.trim())
    .filter(Boolean)
    .join(',');
};

export const formatLookerExpression = (value: string, expressionType: ExpressionType): string => {
  if (!value) return '';
  const values = value
    .split(/[,\n]/)
    .map((v) => v.trim())
    .filter(Boolean);

  if (values.length === 0) return '';

  const result =
    expressionType === 'block' ? values.map((v) => `-%${v}%`).join(',') : values.map((v) => `%${v}%`).join(',');

  return result;
};

export const parseLookerExpression = (expression: string): string => {
  if (!expression) return '';

  const result = expression
    .split(',')
    .map((v) => {
      const trimmed = v.trim();
      if (trimmed.startsWith('-%') && trimmed.endsWith('%')) {
        return trimmed.slice(2, -1);
      }
      if (trimmed.startsWith('%') && trimmed.endsWith('%')) {
        return trimmed.slice(1, -1);
      }
      if (trimmed.startsWith('-')) {
        return trimmed.slice(1);
      }
      return trimmed;
    })
    .filter(Boolean);

  const output = result.join(',\n');

  return output;
};
